import React from 'react';

import { CmsBrowsePage } from 'js/model/cms/cms-browse-page';
import { CmsVenuePage } from 'js/model/cms/cms-venue-page';
import { BrowsePageOutput } from 'js/model/rainbow/browse-page/BrowsePageOutput';
import { createBrowsePageUri } from 'js/helpers/browse-uris';
import { Breadcrumbs } from 'js/components/Breadcrumbs/Breadcrumbs';
import { Results } from 'js/pages/BrowsePage/Results';
import { NoResults } from 'js/pages/BrowsePage/NoResults/NoResults';
import { Context } from 'js/components/LocaleWrapper';
import { Channel } from 'js/model/rainbow/content/ChannelOutput';
import { Dictionary } from 'js/types/generic-types';
import styles from './BrowsePageList.module.css';
import { CmsPageTitle } from './BrowseTitle';
import { BrowsePagination } from './BrowsePagination';

function createPageUriFactory(
  channel: { code: string; languageCode: string },
  pageParameters?: Dictionary<[string]>
): (page: number) => string {
  return (page) => createBrowsePageUri(page, channel, pageParameters);
}

function transformBreadcrumbs(
  locationBreadcrumbs: BrowsePageOutput['locationBreadcrumbs']
): { name: string; uri: string }[] {
  return locationBreadcrumbs.map((item) => ({
    name: item.name,
    uri: item.uri.desktopUri,
  }));
}

interface Props {
  browsePageOutput: BrowsePageOutput;
  loading: boolean;
  onVenueEnter?: (venueId: number, rating: number) => void;
  onVenueLeave?: (venueId: number) => void;
  isInHybridView?: boolean;
}

export class BrowsePageList extends React.Component<Props> {
  static contextType = Context;

  declare context: React.ContextType<typeof Context>;

  public render(): React.ReactNode {
    const cms = this.context.pageData.cms as CmsBrowsePage &
      CmsPageTitle &
      CmsVenuePage;
    const { browsePageOutput } = this.props;
    const showBreadcrumb = Boolean(
      browsePageOutput.specification.location &&
        browsePageOutput.specification.location.tree
    );

    return (
      <>
        {browsePageOutput.results.length > 0 ? (
          <Results
            listingSpecification={browsePageOutput.specification}
            results={browsePageOutput.results}
            channel={this.context.pageData.channel}
            cmsBrowsePage={cms}
            onVenueEnter={this.props.onVenueEnter}
            onVenueLeave={this.props.onVenueLeave}
            isInHybridView={this.props.isInHybridView}
            resultBannerCms={cms.page.browse['result-banner']}
          />
        ) : (
          <NoResults cms={cms.page.browse['no-results']} />
        )}

        <BrowsePagination
          pagination={browsePageOutput.pagination}
          createPageUri={createPageUriFactory(
            this.context.channel as Channel,
            this.context.pageData.pageParameters
          )}
        />
        {showBreadcrumb && (
          <div className={styles.breadcrumbs}>
            <Breadcrumbs
              breadcrumbsParams={transformBreadcrumbs(
                browsePageOutput.locationBreadcrumbs
              )}
              center
            />
          </div>
        )}
      </>
    );
  }
}

BrowsePageList.contextType = Context;
